var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 margin-cards",class:_vm.loadingStatus ? 'cursor-wait' : ''},[_c('UploadFilesSteps',{attrs:{"project":_vm.project,"ingestion-sources":_vm.sources,"save-project-callback":_vm.startLoadingStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }